import { createContext, useContext, useState, ReactNode, FC } from "react";

type LoadingContextData = {
  isLoading: boolean;
  setIsLoading: (value: boolean) => void;
};

export const LoadingContext = createContext<LoadingContextData>({
  isLoading: false,
  setIsLoading: () => {},
});

interface LoadingProviderProps {
  children: ReactNode;
}

export const LoadingProvider: FC<LoadingProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSetIsLoading = (value: boolean) => {
    setIsLoading(value);
  };

  return (
    <LoadingContext.Provider
      value={{
        isLoading,
        setIsLoading: handleSetIsLoading,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoadingContext = () => useContext(LoadingContext);
